import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Tag } from "lucide-react";
import api from "../api";
import { useLang } from "../context/LanguageContext";
import { useSeo } from "../hooks/useSeo";

const Cities = () => {
  const { t } = useLang();
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/cities").then((r) => setCities(r.data.cities || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  useSeo({ title: t("cities.seoTitle"), description: t("cities.seoDesc") });

  const byCountry = cities.reduce((acc, c) => {
    (acc[c.country] = acc[c.country] || []).push(c);
    return acc;
  }, {});
  const countries = Object.keys(byCountry).sort((a, b) =>
    byCountry[b].reduce((n, c) => n + c.dealCount, 0) - byCountry[a].reduce((n, c) => n + c.dealCount, 0));

  return (
    <div className="space-y-8 lp-fade-up" data-testid="cities-page">
      <header className="space-y-2 max-w-3xl">
        <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-foreground">{t("cities.heading")}</h1>
        <p className="text-base md:text-lg text-muted-foreground">{t("cities.subline")}</p>
      </header>

      {loading ? (
        <div className="h-64 rounded-2xl bg-secondary animate-pulse" />
      ) : (
        <div className="space-y-8">
          {countries.map((country) => (
            <section key={country} className="space-y-3" data-testid={`cities-country-${byCountry[country][0].countrySlug}`}>
              <h2 className="text-base md:text-lg font-bold text-foreground">{country}</h2>
              <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
                {byCountry[country].map((c) => (
                  <Link key={c.citySlug} to={`/${c.countrySlug}/${c.citySlug}`}
                    data-testid={`cities-link-${c.countrySlug}-${c.citySlug}`}
                    className="group rounded-2xl border border-border bg-card p-4 hover:border-[#16a34a] hover:-translate-y-0.5 transition-all">
                    <p className="font-bold text-foreground group-hover:text-[#16a34a] transition-colors flex items-center gap-1.5">
                      <MapPin size={15} className="text-[#16a34a]" /> {c.city}
                    </p>
                    <p className="text-xs text-muted-foreground mt-1 flex items-center gap-1.5">
                      <Tag size={12} /> {c.dealCount === 1 ? t("city.liveDealOne") : c.dealCount > 0 ? t("city.liveDeals", { n: c.dealCount }) : t("cities.openingSoon")}
                    </p>
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>
      )}
    </div>
  );
};

export default Cities;
